import Contaier from "../../components/layout/Container/Container";
import CompleteImg from "../../assets/eservice-img-suss.png";
import Header from "../../components/molecules/Header/Header";
import { useNavigate, useLocation } from "react-router-dom";

const HarvestInspectionComplete = () => {
  const location = useLocation();
  const inspectionState = location.state;
  let bannerName = "Dragon Fish (Arowana) Harvest Inspection";

  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/app-inspection`;
    navigate(path);
  };

  return (
    <>
      <Header />
      <Contaier>
        <div className="inner-content pt-5 pb-5">
          <div className="container">
            <div className="landing-page tag-list mt-5 mb-5">
              <figure>
                <img src={CompleteImg} alt="" className="img-fluid" />
              </figure>
              {inspectionState.type !== undefined &&
                inspectionState.type === "dashboard" && (
                  <p>
                    Inspection case {inspectionState.inspectionNumber} has been
                    withdrwan.
                  </p>
                )}
              {(inspectionState.type === undefined ||
                inspectionState.type === "") && (
                <p>
                  Your submission has been successful with inspection case
                  number {inspectionState.inspectionNumber}. The Inspection is
                  scheduled for {inspectionState.date} at {inspectionState.time}
                  . Our officers will review the information, and if there are
                  any changes to the schedule, you will be notified via Email.
                </p>
              )}
              <button
                type="button"
                className="btn btn-success mt-4"
                onClick={routeChange}
              >
                Back to Harvest Inspection
              </button>
            </div>
          </div>
        </div>
      </Contaier>
    </>
  );
};

export default HarvestInspectionComplete;
